import { createFileRoute } from '@tanstack/react-router'
import { Settings } from '@/features/home/components/settings'

export const Route = createFileRoute('/_authenticated/settings/')({
  component: Settings,
})
